var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mfa__Type=MFA",
    className: "mfa__Type=MFA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mfa__Vector",
    className: "mfa__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.268 16.451v-7.91a.177.177 0 0 0-.176-.177H12.26l-.153-.27-.586-1.04v-.14c0-1.404.563-2.347 1.272-2.929.684-.561 1.486-.771 1.985-.771.559 0 1.41.216 2.095.936.622.653 1.055 1.664 1.07 3.155h1.148c.682 0 1.235.553 1.235 1.235v7.911c0 .682-.553 1.235-1.235 1.235h-3.738v-1.058h3.738c.097 0 .176-.08.176-.177Zm-4.49-12.178c-.26 0-.823.129-1.312.53-.446.366-.85.972-.882 1.978l.296.524h4.005c-.014-1.28-.383-2.01-.777-2.424-.454-.477-1.01-.608-1.33-.608Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.88 10.959a.177.177 0 0 0-.177-.177H4.908a.177.177 0 0 0-.176.177v9.02c0 .097.079.176.176.176h9.795c.098 0 .177-.08.177-.176v-9.02ZM9.794 6.205c-.363 0-1.034.17-1.574.736-.474.495-.894 1.344-.86 2.782h4.854c-.004-1.482-.425-2.334-.887-2.818-.521-.548-1.161-.7-1.533-.7ZM15.94 19.98c0 .682-.553 1.235-1.236 1.235H4.908a1.236 1.236 0 0 1-1.235-1.235v-9.02c0-.682.553-1.236 1.235-1.236h1.394c-.034-1.652.452-2.782 1.152-3.514.763-.797 1.721-1.063 2.34-1.063.611 0 1.546.238 2.3 1.029.69.725 1.174 1.858 1.178 3.548h1.431c.683 0 1.236.554 1.236 1.236v9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.754 13.31a.53.53 0 0 1 .745.752L9.22 17.305a.6.6 0 0 1-.843.001L7.113 16.06a.53.53 0 0 1 .743-.754l.941.928 2.957-2.925Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfa);
export default __webpack_public_path__ + "static/media/MFA.06f4119e2b7ddfca6f1ef3564d98997b.svg";
export { ForwardRef as ReactComponent };